import React, { useEffect, useState, useMemo } from "react";

import styled from "styled-components";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import variables from "../../../constants/assets/variables";
import FileUpload from "../../Common/FileUpload";
import NoFooterModal from "../../Common/NoFooterModal";
import * as BulkRevertDisputesActions from "../../../store/actions/Disputes";
import * as UserActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import InformationBar from "../../Common/InformationBar";
import instruction from "../../../constants/Disputes/constants.json";
import {
  BottomSectionModal,
  Link,
  UploadCsvOption,
  NotesSection,
} from "../../../constants/assets/containers";

const FileUploadModal = ({ sendExtraAck, action, serviceOwner, sampleURL, useUserUploadedFilename, setActiveFilePath, getUploadUrl, setStatus, setUploadedFileName }) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [activeFileName, setActiveFileName] = useState("");
  const [file_path, setFile_path] = useState("");
  const handleClose = () => {
    history.push("/disputes");
  };
  const instructions = instruction.instructions;

  const download_url = `${  
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        variables.sampleFileEndPoint
      )}${sampleURL}`
      : ""
    }`;

  const handleSubmit = (e) => {
    e.preventDefault();
    getUploadUrl({
      file_name: activeFileName,
      file_type: activeFile.type,
      action: action,
      service_owner: serviceOwner,
    })
      .then((res) => {
        if (res) {
          setFile_path(res.file_path);
          setCallback_key(res.callback_key);
          setPresign_url(res.file_upload_url);
        } else {
          setStatus({ type: "error", message: Errors.GENERAL_ERROR });
        }
      });
  };

  const handleFileUploadSuccess = () => {
    if (activeFileName) {
      setUploadedFileName(activeFileName);
    }
    setActiveFilePath(file_path);
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "";
  };

  const extraParamsAckObj = useMemo(() => {
    return sendExtraAck
      ? { file_path: file_path, presign_url: presign_url, filename: activeFileName, file_type: activeFile.type}
      : {};
  }, [sendExtraAck, file_path, presign_url]);

  return (
    <BulkUpdateTdsPropertiesModal>
      <NoFooterModal
        header
        heading="Bulk Revert Disputes"
        handleClose={handleClose}
        id="bulkrevertdisputes"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="modal-submit"
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >

        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl="/disputes/bulk_revert/ack"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            activeFileName={activeFileName}
            setActiveFileName={setActiveFileName}
            acceptTypes=".csv, .xls, .xlsx"
            handleFileUploadSuccess={handleFileUploadSuccess}
            addTimestampToFileName={true}
            sendExtraAck={sendExtraAck}
            useUserUploadedFilename={useUserUploadedFilename}
            extraParamsAckObj={extraParamsAckObj}
            validationType={"BulkRevertDisputes"}
          />
        </UploadCsvOption>

        <NotesSection>
          <InformationBar
            sampleUrl={download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </BulkUpdateTdsPropertiesModal>
  );
};

const BulkUpdateTdsPropertiesModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkRevertDisputesActions.getUploadUrl,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setActiveFilePath: bindActionCreators(
      UserActions.setActiveFilePath,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
